import React, { useState } from 'react'
import {
  Button,
  Modal,
  Spin,
  Checkbox,
  message,
  Form,
  Input,
  Card,
  Typography,
  Space,
  Row,
  Col,
  Table,
  Tooltip,
  Select,
  InputNumber,
  Tabs
} from 'antd'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { CheckOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { env } from '../../env'
import { isEmptyObject, loadShowContactUs } from '../../appRedux/actions'
import MultipleLocationsImg from '../../../src/assets/images/Multiple-Locations.png'
import checklistitemsImg from '../../../src/assets/images/checklist-items.png'
import checkImg from '../../../src/assets/images/check-img.png'

const { Title, Text, Link } = Typography
const { REACT_APP_BUS_FIRST_NAME } = env
const { Option } = Select
const { TabPane } = Tabs

const SubscriptionPlans = props => {
  const {
    packageData,
    setPeriod,
    period,
    setOutlet,
    setRegister,
    isFreeTrial,
    outletCount,
    registerCount
  } = props

  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()
  const FormItem = Form.Item
  const [getLoading, setLoading] = React.useState(false)
  const [productGroup, setProductGroup] = React.useState([])
  const [packages, setPackagesData] = React.useState([])
  const [serviceGroup, setServiceGroup] = React.useState([])
  const [isEmailDisplay, setEmailDisplay] = React.useState(true)
  const [priceData, setPriceData] = React.useState([])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!isEmptyObject(packageData)) {
        if (packageData.packages && packageData.packages.length > 0) {
          setPackagesData(packageData.packages)
          const pData = packageData.packages.map(a => {
            return {
              p_p_m: a.pricePerMo,
              p_y_m: a.priceYearlyMo,
              r_p_p_m: a.regPricePerMo,
              r_p_y_m: a.regPriceYearlyMo,
              pkgID: a.packageID
            }
          })
          setPriceData(pData)
        }
        if (
          packageData.packageFeatures &&
          packageData.packageFeatures.length > 0
        ) {
          const prodFeatures = packageData.packageFeatures.filter(
            a => a.groupID == 1
          )
          const serviceFeatures = packageData.packageFeatures.filter(
            a => a.groupID == 2
          )
          setProductGroup(prodFeatures)
          setServiceGroup(serviceFeatures)
        }
      }
    }
    return () => (mounted = false)
  }, [packageData])

  // const ProdColumns = [
  //   {
  //     title: 'PRODUCTS',
  //     dataIndex: 'featureName',
  //     key: 'featureName',
  //     render: text => (
  //       <>
  //         <span style={{ fontSize: 'larger' }}>{text}</span>
  //         {/* <Tooltip title='Information about this feature'>
  //           <InfoCircleOutlined style={{ marginLeft: 16 }} />
  //         </Tooltip> */}
  //       </>
  //     )
  //   },
  //   {
  //     title: 'Basic',
  //     dataIndex: 'basic',
  //     key: 'basic',
  //     render: (text, record) => {
  //       let allow = false
  //       let val = ''
  //       if (record.assigned && record.assigned.length > 0) {
  //         const fa = record.assigned.filter(a => a.packageID == 2)
  //         if (fa && fa.length > 0) {
  //           allow = true
  //           if (record.featureID == 23 && fa[0].value) {
  //             val = fa[0].value
  //           }
  //         }
  //       }
  //       return (
  //         <div>
  //           {allow && (
  //             <>
  //               {!val ? (
  //                 <span
  //                   style={{
  //                     fontSize: 'x-large',
  //                     fontWeight: 'bold',
  //                     color: 'green'
  //                   }}
  //                 >
  //                   <CheckOutlined />
  //                 </span>
  //               ) : (
  //                 <span style={{ fontSize: 'larger' }}>{val}</span>
  //               )}
  //             </>
  //           )}
  //         </div>
  //       )
  //     }
  //   },
  //   {
  //     title: 'Core',
  //     dataIndex: 'core',
  //     key: 'core',
  //     render: (text, record) => {
  //       let allow = false
  //       let val = ''
  //       if (record.assigned && record.assigned.length > 0) {
  //         const fa = record.assigned.filter(a => a.packageID == 3)
  //         if (fa && fa.length > 0) {
  //           allow = true
  //           if (record.featureID == 23 && fa[0].value) {
  //             val = fa[0].value
  //           }
  //         }
  //       }
  //       return (
  //         <div>
  //           {allow && (
  //             <>
  //               {!val ? (
  //                 <span
  //                   style={{
  //                     fontSize: 'x-large',
  //                     fontWeight: 'bold',
  //                     color: 'green'
  //                   }}
  //                 >
  //                   <CheckOutlined />
  //                 </span>
  //               ) : (
  //                 <span style={{ fontSize: 'larger' }}>{val}</span>
  //               )}
  //             </>
  //           )}
  //         </div>
  //       )
  //     }
  //   },
  //   {
  //     title: 'Plus',
  //     dataIndex: 'plus',
  //     key: 'plus',
  //     render: (text, record) => {
  //       let allow = false
  //       let val = ''
  //       if (record.assigned && record.assigned.length > 0) {
  //         const fa = record.assigned.filter(a => a.packageID == 4)
  //         if (fa && fa.length > 0) {
  //           allow = true
  //           if (record.featureID == 23 && fa[0].value) {
  //             val = fa[0].value
  //           }
  //         }
  //       }
  //       return (
  //         <div>
  //           {allow && (
  //             <>
  //               {!val ? (
  //                 <span
  //                   style={{
  //                     fontSize: 'x-large',
  //                     fontWeight: 'bold',
  //                     color: 'green'
  //                   }}
  //                 >
  //                   <CheckOutlined />
  //                 </span>
  //               ) : (
  //                 <span style={{ fontSize: 'larger' }}>{val}</span>
  //               )}
  //             </>
  //           )}
  //         </div>
  //       )
  //     }
  //   }
  // ]

  // const ServiceColumns = [
  //   {
  //     title: 'SERVICES',
  //     dataIndex: 'featureName',
  //     key: 'featureName',
  //     render: text => (
  //       <>
  //         <span style={{ fontSize: 'larger' }}>{text}</span>
  //         {/* <Tooltip title='Information about this feature'>
  //           <InfoCircleOutlined style={{ marginLeft: 8 }} />
  //         </Tooltip> */}
  //       </>
  //     )
  //   },
  //   {
  //     title: 'Basic',
  //     dataIndex: 'basic',
  //     key: 'basic',
  //     render: (text, record) => {
  //       let allow = false
  //       let val = false
  //       if (record.assigned && record.assigned.length > 0) {
  //         const fa = record.assigned.filter(a => a.packageID == 2)
  //         if (fa && fa.length > 0) {
  //           allow = true
  //           if (record.featureID == 23 && fa[0].value) {
  //             val = fa[0].value
  //           }
  //         }
  //       }
  //       return (
  //         <div>
  //           {allow && (
  //             <>
  //               {!val ? (
  //                 <span
  //                   style={{
  //                     fontSize: 'x-large',
  //                     fontWeight: 'bold',
  //                     color: 'green'
  //                   }}
  //                 >
  //                   <CheckOutlined />
  //                 </span>
  //               ) : (
  //                 <span style={{ fontSize: 'larger' }}>{val}</span>
  //               )}
  //             </>
  //           )}
  //         </div>
  //       )
  //     }
  //   },
  //   {
  //     title: 'Core',
  //     dataIndex: 'core',
  //     key: 'core',
  //     render: (text, record) => {
  //       let allow = false
  //       let val = ''
  //       if (record.assigned && record.assigned.length > 0) {
  //         const fa = record.assigned.filter(a => a.packageID == 3)
  //         if (fa && fa.length > 0) {
  //           allow = true
  //           if (record.featureID == 23 && fa[0].value) {
  //             val = fa[0].value
  //           }
  //         }
  //       }
  //       return (
  //         <div>
  //           {allow && (
  //             <>
  //               {!val ? (
  //                 <span
  //                   style={{
  //                     fontSize: 'x-large',
  //                     fontWeight: 'bold',
  //                     color: 'green'
  //                   }}
  //                 >
  //                   <CheckOutlined />
  //                 </span>
  //               ) : (
  //                 <span style={{ fontSize: 'larger' }}>{val}</span>
  //               )}
  //             </>
  //           )}
  //         </div>
  //       )
  //     }
  //   },
  //   {
  //     title: 'Plus',
  //     dataIndex: 'plus',
  //     key: 'plus',
  //     render: (text, record) => {
  //       let allow = false
  //       let val = ''
  //       if (record.assigned && record.assigned.length > 0) {
  //         const fa = record.assigned.filter(a => a.packageID == 4)
  //         if (fa && fa.length > 0) {
  //           allow = true
  //           if (record.featureID == 23 && fa[0].value) {
  //             val = fa[0].value
  //           }
  //         }
  //       }
  //       return (
  //         <div>
  //           {allow && (
  //             <>
  //               {!val ? (
  //                 <span
  //                   style={{
  //                     fontSize: 'x-large',
  //                     fontWeight: 'bold',
  //                     color: 'green'
  //                   }}
  //                 >
  //                   <CheckOutlined />
  //                 </span>
  //               ) : (
  //                 <span style={{ fontSize: 'larger' }}>{val}</span>
  //               )}
  //             </>
  //           )}
  //         </div>
  //       )
  //     }
  //   }
  // ]

  const handleTabChange = key => {
    // registerChange(registerCount)
    outletChange(outletCount, key ? parseInt(key) : 2)
    setPeriod(key ? parseInt(key) : 2)
  }

  function onPackageSelect (pkgID) {
    if (isFreeTrial) {
      window.location.href = '/signup'
    } else {
      window.location.href = `/store/request/${outletCount}/${registerCount}/${pkgID}/${period}`
    }
  }

  function outletChange (q, isPeriod) {
    let data = [...packages]
    if (data && data.length > 0) {
      const cycle = isPeriod ? isPeriod : period
      data.map(da => {
        const pricing = priceData.filter(a => a.pkgID == da.packageID)[0]
        if (cycle && cycle == 1) {
          // for monthly
          if (q < registerCount) {
            da.pricePerMo =
              pricing.p_p_m * q + pricing.r_p_p_m * (registerCount - q)
          } else {
            da.pricePerMo = pricing.p_p_m * q
          }
        } else if (cycle && cycle == 2) {
          // for annually
          if (q < registerCount) {
            da.priceYearlyMo =
              pricing.p_y_m * q + pricing.r_p_y_m * (registerCount - q)
            // pricing.priceYearlyMo * q * 12 +
            // pricing.regPriceYearlyMo * (registerCount - q) * 12
          } else {
            da.priceYearlyMo = pricing.p_y_m * q
            // da.priceYearlyMo = pricing.priceYearlyMo * q * 12
          }
        }
      })
      if (q > registerCount) {
        setRegister(q)
      }
      setPackagesData(data)
      setOutlet(q)
    } else {
      setOutlet(1)
    }
  }

  function registerChange (q) {
    let data = [...packages]
    if (data && data.length > 0) {
      data.map(da => {
        const pricing = priceData.filter(a => a.pkgID == da.packageID)[0]
        if (period && period == 1) {
          // for monthly
          if (outletCount < q) {
            da.pricePerMo =
              pricing.p_p_m * outletCount + pricing.r_p_p_m * (q - outletCount)
          } else {
            da.pricePerMo = pricing.p_p_m * outletCount
          }
        } else if (period && period == 2) {
          // for annually
          if (outletCount < q) {
            da.priceYearlyMo =
              pricing.p_y_m * outletCount + pricing.r_p_y_m * (q - outletCount)
            // pricing.p_y_m * outletCount * 12 +
            // pricing.r_p_y_m * (q - outletCount) * 12
          } else {
            da.priceYearlyMo = pricing.p_y_m * outletCount
            // da.priceYearlyMo = pricing.priceYearlyMo * outletCount * 12
          }
        }
      })
      setRegister(q)
      setPackagesData(data)
    }
  }

  return (
    <Spin tip={'Loading'} spinning={getLoading} size='large'>
      <div className='BillingPlan-Container'>
        <div className='subscription-header div-flow mb-0'>
          <h2>
            Get ready for the future of Point of Sale with<br></br>{' '}
            <span> {REACT_APP_BUS_FIRST_NAME}!</span>
          </h2>

          <div className='input-group-subscription'>
            <label className='mb-0'>Number of Outlets</label>
            <InputNumber
              min={1}
              value={outletCount}
              placeholder='Number of locations'
              onChange={outletChange}
            />
            <label className='mb-0'>Number of Registers</label>
            <InputNumber
              min={1}
              value={registerCount}
              onChange={registerChange}
              placeholder='Number of registers'
            />
          </div>

          <Tabs
            size='large'
            activeKey={`${period}`}
            style={{ marginTop: 20, alignItems: 'center' }}
            onChange={handleTabChange}
          >
            <TabPane tab='Annually' key='2'></TabPane>
            <TabPane tab='Monthly' key='1'></TabPane>
          </Tabs>
        </div>

        <div class='div-flow mb-4'>
          <div class='bp-pricing-table-div table-responsive'>
            <table class='price-table'>
              <tbody>
                <tr class='price-table-head'>
                  <td></td>
                  {packages && packages.length > 0 && (
                    <>
                      {packages.map((a, key) => {
                        return <td key={key}>{a.packageTitle}</td>
                      })}
                    </>
                  )}
                </tr>
                <tr className='bp-table-header'>
                  <td></td>
                  {packages && packages.length > 0 && (
                    <>
                      {packages.map((a, key) => {
                        return (
                          <td class='plan-price' key={key}>
                            <p className='mt-3 mb-0'>{a.packageDescription}</p>
                            <div class='price-div mt-2 mb-2'>
                              {period == 1
                                ? `${a.pricePerMo} ${a.currencyCode} /mo`
                                : `${a.priceYearlyMo} ${a.currencyCode} /mo`}
                            </div>
                            <button
                              className='ant-btn ant-btn-primary mb-3'
                              onClick={() => onPackageSelect(a.packageID)}
                            >
                              Select
                            </button>
                          </td>
                        )
                      })}
                    </>
                  )}
                </tr>
                <tr>
                  <td class='bp-table-heading' colspan='4'>
                    <h2 class='mb-0'>PRODUCTS</h2>
                  </td>
                </tr>

                {productGroup &&
                  productGroup.length > 0 &&
                  productGroup.map((a, key) => {
                    let base_allow = false
                    let core_allow = false
                    let plus_allow = false
                    let base_val = ''
                    let core_val = ''
                    let plus_val = ''
                    if (a.assigned && a.assigned.length > 0) {
                      const base_fa = a.assigned.filter(a => a.packageID == 2)
                      const core_fa = a.assigned.filter(a => a.packageID == 3)
                      const plus_fa = a.assigned.filter(a => a.packageID == 4)
                      if (base_fa && base_fa.length > 0) {
                        base_allow = true
                        if (a.featureID == 23 && base_fa[0].value) {
                          base_val = base_fa[0].value
                        }
                      }
                      if (core_fa && core_fa.length > 0) {
                        core_allow = true
                        if (a.featureID == 23 && core_fa[0].value) {
                          core_val = core_fa[0].value
                        }
                      }
                      if (plus_fa && plus_fa.length > 0) {
                        plus_allow = true
                        if (a.featureID == 23 && plus_fa[0].value) {
                          plus_val = plus_fa[0].value
                        }
                      }
                    }
                    return (
                      <tr key={key}>
                        <td>{a.featureName}</td>
                        <td>
                          {base_allow && (
                            <>
                              {!base_val ? (
                                <img
                                  src={checkImg}
                                  className='bp-checkImg'
                                  alt='Check Sign'
                                />
                              ) : (
                                base_val
                              )}
                            </>
                          )}
                        </td>
                        <td>
                          {core_allow && (
                            <>
                              {!core_val ? (
                                <img
                                  src={checkImg}
                                  className='bp-checkImg'
                                  alt='Check Sign'
                                />
                              ) : (
                                core_val
                              )}
                            </>
                          )}
                        </td>
                        <td>
                          {plus_allow && (
                            <>
                              {!plus_val ? (
                                <img
                                  src={checkImg}
                                  className='bp-checkImg'
                                  alt='Check Sign'
                                />
                              ) : (
                                plus_val
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                    )
                  })}

                {/* ///////////////////////// */}

                <tr>
                  <td class='bp-table-heading' colspan='4'>
                    <h2 class='mb-0'>SERVICES</h2>
                  </td>
                </tr>
                {serviceGroup &&
                  serviceGroup.length > 0 &&
                  serviceGroup.map((a, key) => {
                    let base_allow = false
                    let core_allow = false
                    let plus_allow = false
                    let base_val = ''
                    let core_val = ''
                    let plus_val = ''
                    if (a.assigned && a.assigned.length > 0) {
                      const base_fa = a.assigned.filter(a => a.packageID == 2)
                      const core_fa = a.assigned.filter(a => a.packageID == 3)
                      const plus_fa = a.assigned.filter(a => a.packageID == 4)
                      if (base_fa && base_fa.length > 0) {
                        base_allow = true
                        if (a.featureID == 23 && base_fa[0].value) {
                          base_val = base_fa[0].value
                        }
                      }
                      if (core_fa && core_fa.length > 0) {
                        core_allow = true
                        if (a.featureID == 23 && core_fa[0].value) {
                          core_val = core_fa[0].value
                        }
                      }
                      if (plus_fa && plus_fa.length > 0) {
                        plus_allow = true
                        if (a.featureID == 23 && plus_fa[0].value) {
                          plus_val = plus_fa[0].value
                        }
                      }
                    }
                    return (
                      <tr key={key}>
                        <td>{a.featureName}</td>
                        <td>
                          {base_allow && (
                            <>
                              {!base_val ? (
                                <img
                                  src={checkImg}
                                  className='bp-checkImg'
                                  alt='Check Sign'
                                />
                              ) : (
                                base_val
                              )}
                            </>
                          )}
                        </td>
                        <td>
                          {core_allow && (
                            <>
                              {!core_val ? (
                                <img
                                  src={checkImg}
                                  className='bp-checkImg'
                                  alt='Check Sign'
                                />
                              ) : (
                                core_val
                              )}
                            </>
                          )}
                        </td>
                        <td>
                          {plus_allow && (
                            <>
                              {!plus_val ? (
                                <img
                                  src={checkImg}
                                  className='bp-checkImg'
                                  alt='Check Sign'
                                />
                              ) : (
                                plus_val
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                    )
                  })}
              </tbody>
            </table>

            <div class='bp-disclaimer'>
              <h3 class='mb-0'>
                Please note that prices can vary and additional service fees may
                apply depending on the nature of the business and the industry.
              </h3>
            </div>
          </div>
        </div>

        {/* <div class='packages-pricing div-flow'>
          <Row gutter={[16, 16]} justify='end'>
            {packages && packages.length > 0 && (
              <>
                {packages.map((a, key) => {
                  return (
                    <Col span={6} className='bp-price-border'>
                      <Card
                        title={
                          <span className='bp-heading'>{a.packageTitle}</span>
                        }
                        bordered={false}
                        headStyle={{ textAlign: 'center' }}
                        bodyStyle={{ textAlign: 'center' }}
                      >
                        <p>{a.packageDescription}</p>
                        <h3 className='package-price'>
                          {period == 1 ? (
                            <span>{`${a.pricePerMo} ${a.currencyCode} /mo`}</span>
                          ) : (
                            <span>{`${a.priceYearlyMo} ${a.currencyCode} /mo`}</span>
                          )}
                        </h3>
                        <Button
                          type='primary'
                          size='large'
                          onClick={() => onPackageSelect(a.packageID)}
                        >
                          Select
                        </Button>
                      </Card>
                    </Col>
                  )
                })}
              </>
            )}
          </Row>

          <Table
            dataSource={productGroup}
            columns={ProdColumns}
            pagination={false}
            className='bp-table'
          />

          <Table
            dataSource={serviceGroup}
            columns={ServiceColumns}
            pagination={false}
            className='bp-table'
          />

          <div className='bp-disclaimer'>
            <h3 className='mb-0'>
              Please note that prices can vary and additional service fees may
              apply depending on the nature of the business and the industry.
            </h3>
          </div>
        </div> */}

        <div class='customized-POS div-flow'>
        <Row className='text-center'>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <img
                src={checklistitemsImg}
                className='bp-img'
                alt='POS Hardware'
              />
              <h1 className='mb-0'>
                Want a customized solution? We've got it.
              </h1>
              <p>
                Whether you're stationing your POS on the counter or walking
                around with an iPad, {REACT_APP_BUS_FIRST_NAME} will help you
                find the right retail customized setup. Your perfect wireless
                experience awaits.
              </p>
              <div style={{ marginTop: '20px' }}>
                <Button
                  type='primary'
                  size='large'
                  onClick={() => dispatch(loadShowContactUs(true))}
                >
                  Talk to Us
                </Button>
              </div>
            </Col>

            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <img
                src={MultipleLocationsImg}
                className='bp-img2'
                alt='Locations'
              />
              <h1 className='mb-0'>
                Customized solution or multiple locations?
              </h1>
              <p>
                No problem. Get in touch with us today so we can create your
                custom plan together.
              </p>
              <div style={{ marginTop: '20px' }}>
                <Button
                  type='primary'
                  size='large'
                  onClick={() => dispatch(loadShowContactUs(true))}
                >
                  Talk to Us
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </Spin>
  )
}

export default SubscriptionPlans
